import {GLOBAL_KNOWLEDGE_BASE_ORIGIN} from "../../config/origin";

const docIcon = require('../../assets/images/icon-doc-mini.png');
const pptIcon = require('../../assets/images/icon-ppt-mini.png');
const xlsxIcon = require('../../assets/images/icon-xlsx-mini.png');
const zipIcon = require('../../assets/images/icon-zip-mini.png');
const pdfIcon = require('../../assets/images/icon-pdf-mini.png');
const jpgIcon = require('../../assets/images/icon-jpg-mini.png');
const otherIcon = require('../../assets/images/icon-other-mini.png');
const iconDict = [
    {name: ['doc', 'docx'], icon: docIcon},
    {name: ['ppt', 'pptx'], icon: pptIcon},
    {name: ['xls', 'xlsx'], icon: xlsxIcon},
    {name: ['zip', 'rar'], icon: zipIcon},
    {name: ['pdf'], icon: pdfIcon},
    {name: ['jpg', 'jpeg', 'png'], icon: jpgIcon},
]


/**
 * 获取附件图片URL
 * @param name
 */
export const getAttachmentIconURL = (fileName: string): string => {
    // 获取文件后缀
    let url = otherIcon;
    if (fileName) {
        let suffix = fileName.split('.').slice(-1)[0];
        let target = iconDict.find((v: any) => v.name.includes(suffix));
        if (target) {
            url = target.icon;
        }
    }
    return url;
}


/**
 * 打开附件预览页
 * @param fileInfo
 */
export const openAttachmentPreviewer = (fileInfo: {url, fileName?}) => {
    window.open(`${GLOBAL_KNOWLEDGE_BASE_ORIGIN}/#/attachmentPreviewer/${encodeURIComponent(fileInfo.url)}${fileInfo.fileName ? `/${fileInfo.fileName}` : ''}`);
}
